module.exports = __webpack_public_path__ + "img/Payment-On-Delivery.a6c6353b.jpg";